import React from 'react'
import {always, map, pipe, range} from 'ramda'
import LetterButton from './LetterButton'

const letters = map(String.fromCharCode, range(97, 123))

const Letters = pipe(always(letters), map(renderLetter))

export default Letters

function renderLetter(letter) {
  return React.createElement(LetterButton, {letter, key: letter})
}